module.exports = __webpack_public_path__ + "img/toilet_male.cdde12a3.png";